import React from 'react';
import MediaQuery from 'react-responsive';
import { FormattedMessage } from 'react-intl';
import { Items } from '../../Routes';
import { Link } from 'react-router-dom';

const Navigation = (props) => {
    return (
        <div className="navbar-custom">
            <div className="container-fluid">
                <div id="navigation">
                    <ul className="navigation-menu">
                        <MediaQuery minWidth={992}>
                            { Items.slice(1, -1).map((item, index) => { 
                                return <li key={index}><Link to={item.path} className={props.color}>
                                    <FormattedMessage id={item.name}/></Link></li> 
                            }) }
                        </MediaQuery>
                        <MediaQuery maxWidth={991}>
                            { Items.slice(1, -1).map( (item, index) => { 
                                return <li key={index}><Link to={item.path} className="text-dark">
                                    <FormattedMessage id={item.name}/></Link></li>
                            }) }
                        </MediaQuery>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Navigation;